// extracted by mini-css-extract-plugin
module.exports = {"email":"M-wAi","recaptcha":"uXOKP","icon":"_0l9O1","label":"ghv2P","message":"WHeTe"};